<template>
  <v-app-bar color="cyan darken-1" class="toolbar-boxes" fixed dark app>
    <v-app-bar-nav-icon @click.stop="drawerToggle"></v-app-bar-nav-icon>
    <v-toolbar-title class="body-2">
      {{ userName }} <br />
      <span class="subheading"
        ><b class="subtitle-2">{{ roleName }}</b></span
      >
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn icon @click="fullScreen()">
      <v-icon>{{ icon_fs }}</v-icon>
    </v-btn>
    <v-menu
      offset-y
      origin="center center"
      :nudge-bottom="10"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-avatar size="40px">
            <img v-bind:src="require('../assets/user.svg')" alt="User" />
          </v-avatar>
        </v-btn>
      </template>
      <v-list class="pa-0">
        <v-subheader>Opciones</v-subheader>
        <v-divider></v-divider>
        <v-list-item @click="perfil()" ripple="ripple" rel="noopener">
          <v-list-item-icon>
            <v-icon>mdi-account-edit</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Perfil</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="logout()" ripple="ripple" rel="noopener">
          <v-list-item-icon>
            <v-icon color="error">mdi-close</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Salir</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>
<script>
import Util from "../utils/storage";
export default {
  name: "toolbar",
  data: () => ({
    icon_fs: "mdi-fullscreen",
    userName: "",
    roleName: "",
    role: 0,
  }),
  mounted() {
    if (Util.getUser()) {
      this.userName = Util.getUser().name;
      this.roleName = Util.getUser().rol;
      this.role = Util.getUser().role;
    }
  },
  methods: {
    drawerToggle() {
      window.getApp.$emit("DRAWER_TOGGLE");
    },
    fullScreen() {
      let doc = window.document;
      let docEl = doc.documentElement;

      let requestFullScreen =
        docEl.requestFullscreen ||
        docEl.mozRequestFullScreen ||
        docEl.webkitRequestFullScreen ||
        docEl.msRequestFullscreen;
      let cancelFullScreen =
        doc.exitFullscreen ||
        doc.mozCancelFullScreen ||
        doc.webkitExitFullscreen ||
        doc.msExitFullscreen;

      if (
        !doc.fullscreenElement &&
        !doc.mozFullScreenElement &&
        !doc.webkitFullscreenElement &&
        !doc.msFullscreenElement
      ) {
        requestFullScreen.call(docEl);
        this.icon_fs = "mdi-fullscreen-exit";
      } else {
        cancelFullScreen.call(doc);
        this.icon_fs = "mdi-fullscreen";
      }
    },

    logout() {
      this.$store.dispatch("logout").then(() => {
        if (this.$router.currentRoute.name != "signin") {
          this.$router.replace({ name: "signin" });
        }
      });
    },

    perfil() {
      this.$router.push({ name: "profile" });
    },
  },
};
</script>
